'use strict';

const angular = require('angular');

const plannerService = require('./services/plannerService');
const inventoryService = require('./services/inventoryService');
const translationService = require('./services/translationService');

angular
    .module('app.services', [])
    .service('plannerService', plannerService)
    .service('inventoryService', inventoryService)
    .service('translationService', translationService);



// WEBPACK FOOTER //
// ./widgets/services.js